import type { HbBidderConfig } from '../types'

const PUBLISHER_ID = '168522'

export const PUBMATIC_BANNER: HbBidderConfig = {
    bidder: 'pubmatic',
    params: ({ adSource }) =>
        adSource === 'native'
            ? undefined
            : {
                  publisherId: PUBLISHER_ID,
                  adSlot: '7815243',
              },
}

export const PUBMATIC_VIDEO: HbBidderConfig = {
    bidder: 'pubmatic',
    params: ({ adSource }) =>
        adSource === 'native'
            ? undefined
            : {
                  publisherId: PUBLISHER_ID,
                  adSlot: '7815245',
              },
}
